import styled from "styled-components";
import {
  Container,
  Title as SundayTitle,
  Body as SundayBody,
} from "sunday-component";
import {
  List,
  Dropdown as AntdDropdown,
  Drawer as AntdDrawer,
  Tag,
} from "antd";
import { color } from "src/styles/globals";
import { down } from "styled-breakpoints";
import Button from "../../Button";
import CommonDivider from "../../Divider";

export const MenuDropdown = styled(AntdDropdown)``;

export const ProfileIconContainer = styled.div`
  border: 1px solid ${color.charcoal03};
  border-radius: 50%;
  height: 32px;
  width: 32px;
`;

export const SundayLogoContainer = styled.div`
  width: fit-content;
  margin-right: 40px;
  ${down("md")} {
    margin: 0px;
  }
`;

export const MobileProfileIconContainer = styled.div`
  cursor: pointer;
  border: 1px solid ${color.charcoal03};
  border-radius: 50%;
  height: 40px;
  width: 40px;
`;

export const DesktopLoginButton = styled(Button).attrs({ type: "outlined" })<{
  iconExists: boolean;
  active: boolean;
}>`
  padding: ${(props) => (props.iconExists ? "7px" : "11px 16px")};
  max-height: 48px;
  max-width: 209px;

  &.sunday-component-btn-default {
    border-radius: 100px;
    background-color: ${(props) =>
      props.active
        ? "var(--ui-form-button-primary-enabled-background-color)"
        : "var(--ui-form-button-secondary-enabled-background-color)"};
    border-color: ${(props) =>
      props.active
        ? "var(--ui-form-button-primary-enabled-border-color)"
        : "var(--ui-form-button-secondary-enabled-border-color)"};
    * {
      color: ${(props) =>
        props.active
          ? "var(--ui-form-button-primary-enabled-text-color)"
          : "var(--ui-form-button-secondary-enabled-text-color)"};
    }
    &:hover {
      border-radius: 100px;
      background-color: var(--ui-form-button-primary-enabled-background-color);
      border-color: ${color.charcoal03};
      * {
        color: var(--ui-form-button-primary-enabled-text-color);
      }
    }
    &:focus {
      border-radius: 100px;
      background-color: ${(props) =>
        props.active
          ? "var(--ui-form-button-primary-enabled-background-color)"
          : "var(--ui-form-button-secondary-enabled-background-color)"};
      border-color: ${(props) =>
        props.active
          ? "var(--ui-form-button-primary-enabled-border-color)"
          : "var(--ui-form-button-secondary-enabled-border-color)"};
      * {
        color: ${(props) =>
          props.active
            ? "var(--ui-form-button-primary-enabled-text-color)"
            : "var(--ui-form-button-secondary-enabled-text-color)"};
      }
    }
    &:disabled {
      border-radius: 100px;
      background-color: var(
        --ui-form-button-secondary-disabled-background-color
      );
      border-color: var(--ui-form-button-secondary-disabled-border-color);
      * {
        color: var(--ui-form-button-secondary-disabled-text-color);
      }
    }
  }

  &.sunday-component-btn-text {
    padding: 0px;
    height: fit-content;
    width: fit-content;
    * {
      color: var(--ui-form-button-text-enabled-text-color);
    }

    &:hover {
      * {
        color: var(--ui-form-button-text-hover-text-color);
        text-decoration: var(--ui-form-button-text-hover-text-decoration);
        text-decoration-color: var(--ui-form-button-text-hover-text-color);
      }
    }
    &:focus {
      * {
        color: var(--ui-form-button-text-focused-text-color);
        text-decoration: var(--ui-form-button-text-focused-text-decoration);
        text-decoration-color: var(--ui-form-button-text-focused-text-color);
      }
    }
    &:disabled {
      * {
        color: var(--ui-form-button-text-disabled-text-color);
        text-decoration: none;
      }
    }
  }

  .sunday-component-btn:active,
  .sunday-component-btn:focus,
  .sunday-component-btn:hover {
    background: ${color.carrotOrange03};
    border: 1px solid ${color.charcoal03};
  }
`;

export const MobileLoginButton = styled(Button)`
  padding: 10px;
  max-height: 40px;
`;

export const LoginButtonBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
`;

export const ButtonTitle = styled(SundayTitle).attrs({ level: 7 })`
  max-width: 153px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Header = styled.header``;

export const HeaderContainer = styled(Container)`
  height: 120px;
  background-color: white;
  position: relative;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${color.charcoal03};
  z-index: 30;
  @media only screen and (max-width: 767px) {
    height: 56px;
  }
  @media only screen and (min-width: 992px) and (max-width: 1199px) and (orientation: portrait) {
    height: 56px;
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    height: 56px;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  column-gap: 40px;
  flex-grow: 0;
  flex-shrink: 0;
`;

export const SubMenuContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
  flex-grow: 0;
  flex-shrink: 0;
`;

export const MenuIcon = styled.img``;

export const MenuText = styled(SundayTitle)`
  color: ${color.charcoal10};
  margin-left: 8px;
`;

export const LogOutMenuText = styled(SundayTitle)`
  color: ${color.errorRed02};
  margin-left: 8px;
`;

export const MenuDropdownList = styled(List)`
  background: white;
  padding: 0px;
  border-radius: 8px;
  overflow: hidden;
  .ant-dropdown-menu,
  ul {
    margin: 0px;
    padding: 0px;
  }
  .ant-dropdown-menu-items {
    border-radius: 8px;
    padding: 0px;
  }
  .ant-list-item {
    padding: 16px;
  }
`;

export const MenuDropdownOption = styled(List.Item)`
  display: flex;
  justify-content: space-between;
  align-items: start;
  cursor: pointer;
  &:hover {
    background-color: ${color.charcoal03};
  }
`;

export const MenuDropdownDisplay = styled(List.Item)``;

export const Drawer = styled(AntdDrawer)`
  box-shadow: none;
  z-index: 999;
  .ant-drawer-body {
    padding: 0;
    height: fit-content;
  }
`;

export const DrawerMenuOptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  &:hover {
    background-color: ${color.charcoal03};
  }
  padding: 16px;
`;

export const DrawerMenuDisplayContainer = styled.div`
  padding: 16px;
`;

export const ProfileInfoContainer = styled.div<{ fullSize: boolean }>`
  max-width: 178px;
  max-width: ${(props) => (props.fullSize ? "224px" : "178px")};
  margin-left: 16px;
`;

export const ProfileNameTitle = styled(SundayTitle)`
  overflow-wrap: break-word;
  color: ${color.charcoal10};
`;

export const MobileNumberBody = styled(SundayBody)`
  color: ${color.charcoal10};
`;

export const Divider = styled(CommonDivider)`
  margin: 0px;
`;

export const DividerSpace = styled.div`
  background: ${color.charcoal01};
  height: 18px;
`;

export const NewBadge = styled(Tag).attrs({
  color: color.errorRed03,
})`
  border-radius: 12px;
  margin: 0;
`;

export const NewBadgeText = styled(SundayTitle).attrs({ level: 7 })`
  color: white;
  font-size: 17px;
`;
